import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import React, {
    useCallback, useState, useMemo, useContext, useEffect
} from 'react';
import { withRouter, Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import { Icon, Loader, DropdownSelectField, ModalNextProvider } from '@jutro/components';
import { useDependencies } from 'gw-portals-dependency-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { getFontIcon, getProductName } from '../../customer/utils/lobIconUtil';
import metadata from './GoPaperless.metadata.json5';
import messages from './GoPaperless.messages';
import styles from './GoPaperless.module.scss';

const SAVE_MESSAGES = {
    saveDocPreferenceSuccess: 'saveDocPreferenceSuccess',
    saveDocPreferenceError: 'saveDocPreferenceError'
};

function GoPaperless(props) {
    const [formData, updateFormData] = useState({});
    const [accountPolicyData, updateAccountPolicyData] = useState([]);
    const [policyDocConsentValue, updatePolicyDocConsentValue] = useState(false);
    const [status, updateStatus] = useState(null);
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [isLoading, setIsLoading] = useState(false);
    const { PolicyService } = useDependencies('PolicyService');
    const viewModelService = useContext(ViewModelServiceContext);
    const location = useLocation();
    const[showPaperlessNotification,setPaperlessNotification]= useState(false);

    const createPolicySummaryVM = (data) => {
        return viewModelService.create(
            data,
            'pc',
            'edge.capabilities.policy.dto.PolicyBasicDetailsDTO'
        );
    };

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
            updateStatus('');
        },
        [formData]
    );

    const writeDocPreferenceValue = useCallback(
        (value, path, index) => {
            const today = new Date()
            if( value == "DigitiallyDelivered"){
                accountPolicyData[index].electronicConsent_EY = today
            }else if(value !== "DigitiallyDelivered"){
                accountPolicyData[index].electronicConsent_EY = ""
            }
            accountPolicyData[index].policyDocDispatchMode.value = value;
            updateAccountPolicyData(_.clone(accountPolicyData));
        },
        [accountPolicyData]
    );

    const getDocumentPreferenceAvailableValues=(accountData)=>{
        //Logic to make electronic delivery as first option in the dropdown
        if(accountData.dispatchMode_EY.includes('DigitiallyDelivered')){
            let data = accountData;
            let paperlessOptionCode = data.dispatchMode_EY.filter((data)=>{return (data === 'DigitiallyDelivered')});
            let nonPaperlessOptionsCode = data.dispatchMode_EY.filter((data)=>{return (data !== 'DigitiallyDelivered')});
            //logic to make simple summary as first option
            let paperlessSimplePackageCode = nonPaperlessOptionsCode.filter((data)=>{return (data === 'MailToInsuredSimpleSummary')});
            let remainigOptionsCode= nonPaperlessOptionsCode.filter((data)=>{return (data !== 'MailToInsuredSimpleSummary')});
            let directBillOptions = paperlessSimplePackageCode.concat(remainigOptionsCode);
            let requiredData = paperlessOptionCode.concat(directBillOptions);
              //logic to make simple summary code as first option
            let paperlessOption = data.dispatchMode_EYValue.filter((data)=>{return (data === 'Electronic Delivery to You')});
            let nonPaperlessOptions = data.dispatchMode_EYValue.filter((data)=>{return (data !== 'Electronic Delivery to You')});
            let paperlessSimplePackageName = nonPaperlessOptions.filter((data)=>{return (data === 'Mail - Simple Summary')});
            let remainigOptionsName = nonPaperlessOptions.filter((data)=>{return (data !== 'Mail - Simple Summary')});
            let directBillOptionsName = paperlessSimplePackageName.concat(remainigOptionsName);
            let newrequiredData = paperlessOption.concat(directBillOptionsName);
              return requiredData.map((code, i) => {
                    return {
                        code: code,
                        name: `${newrequiredData[i]}`
                    };
              })
		}else{
            return accountData.dispatchMode_EYValue.map((code, i) => {
                return {
                    code: `${accountData.dispatchMode_EY[i]}`,
                    name: `${accountData.dispatchMode_EYValue[i]}`
                };
            });
         }
    }

    const getDocumentPreference = useCallback((item, index, { path: property }) => {
        const value = accountPolicyData[index].value.policyDocDispatchMode
        if(!(accountPolicyData[index].value.dispatchMode_EYValue.includes(accountPolicyData[index].value.policyDocDispatchModeValue))){
            if(accountPolicyData[index].value.policyDocDispatchModeValue === 'Dispatch mode is Email'){
                //accountPolicyData[index].value.dispatchMode_EYValue.push('DIRECT BILL–Insured policy documents delivered digitally via Optim')
                accountPolicyData[index].value.dispatchMode_EYValue.push('Electronic Delivery to You');
                accountPolicyData[index].value.dispatchMode_EY.push(accountPolicyData[index].value.policyDocDispatchMode);
            }else if(accountPolicyData[index].value.policyDocDispatchModeValue === 'Post'){
                //accountPolicyData[index].value.dispatchMode_EYValue.push('DIRECT BILL–Insured policy documents delivered by mail to Insured from HMI');
                accountPolicyData[index].value.dispatchMode_EYValue.push('Direct Mail');
                accountPolicyData[index].value.dispatchMode_EY.push(accountPolicyData[index].value.policyDocDispatchMode);
            }else{
                accountPolicyData[index].value.dispatchMode_EYValue.push(accountPolicyData[index].value.policyDocDispatchModeValue);
                accountPolicyData[index].value.dispatchMode_EY.push(accountPolicyData[index].value.policyDocDispatchMode);
            }
        }else{
            accountPolicyData[index].value.dispatchMode_EYValue;
            accountPolicyData[index].value.dispatchMode_EY
        }
        return (
            <DropdownSelectField
                id={`property${index}`}
                alwaysShowPlaceholder={false}
                // availableValues={accountPolicyData[index].value.dispatchMode_EYValue.map((code, i) => {
                //     return {
                //         code: `${accountPolicyData[index].value.dispatchMode_EY[i]}`,
                //         name: code
                //     };
                // })}
                path={accountPolicyData[index].policyDocDispatchMode}
                onValueChange={(value, path) => writeDocPreferenceValue(value, path, index)}
                value={accountPolicyData[index].value.policyDocDispatchMode}
                className={styles.involvmentInjuredDropDown}
                availableValues={getDocumentPreferenceAvailableValues(accountPolicyData[index].value)}
            />
        );
    }, [accountPolicyData]);

    const getDataCell = (item, index, { path: property }) => {
        if(property === "electronicConsent_EY"){
           if(item[property].value){
            return (<div>{translator(messages.agree)}</div>)
           }else{
            return(<div> </div>)
           }
        }else {
            // For all other properties, check if item[property] exists and has a value
            if (item[property] && item[property].value) {
                return (
                    <div>
                        {item[property].value}
                    </div>
                );
            } else {
                return (
                    <div> </div>
                );
            }
        }
       
    };

    // const renderCustomHeader = () => (
    //     <div style={{ display: 'flex', alignItems: 'center' }}>
    //       <span>{translator(messages.renewalDocPrefrence)}</span>
    //       <i
    //         className="fa fa-info-circle"
    //         style={{ marginLeft: '8px', cursor: 'pointer' }}
    //         title="Your broker has signed you up for a change in Document Delivery Preference upon Renewal. This will take effect on your next policy term."
    //       />
    //     </div>
    //   );

    const getProductIcon = useCallback((item) => {
        const icon = getFontIcon(item.productCode.value);
        return <Icon role="img" className={styles.policyTypeIcon} icon={icon} title={getProductName(item.productCode)} key={item.productCode} />;
    }, []);

    useEffect(() => {
        setIsLoading(true);
        if(location.state){
           setPaperlessNotification(true);
          }else{
            setPaperlessNotification(false);
          }
        PolicyService.getUserPolicySummaries(authHeader)
            .then((responseData) => {
                if (responseData && responseData.length > 0) {
                    const hoAndAutoPolicies = responseData.filter((data) => data.periods && data.periods.length > 0
                        && (data.billingMethod_EY === 'DirectBill'))
                        .map((policySummary) => {
                            return createPolicySummaryVM({
                                policyNumber: policySummary.policyNumber,
                                productCode: policySummary.periods[0].productCode,
                                accountNumber: policySummary.accountNumber,
                                policyDocDispatchMode: policySummary.policyDocDispatchMode,
                                policyDocDispatchModeValue: policySummary.policyDocDispatchModeValue,
                                dispatchMode_EYValue : policySummary.dispatchMode_EYValue,
                                dispatchMode_EY: policySummary.dispatchMode_EY,
                                // renewalDocPref_EY: policySummary.renewalDocPref_EY,
                                // renewalDocPref_EYValue: policySummary.renewalDocPref_EYValue,
                                electronicConsent_EY: policySummary.electronicConsent_EY ? policySummary.electronicConsent_EY : "",
                                
                            });
                        });
                    updateAccountPolicyData(hoAndAutoPolicies);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
            setIsLoading(false);
        });
    }, [PolicyService, authHeader]);

    const updatePolicyDocEmailConsentValue = (value) => {
        updatePolicyDocConsentValue(value);
    }

    const isEmailOptionSelected = useMemo(() => {
        return accountPolicyData.filter((data) => data.policyDocDispatchMode.value && (data.policyDocDispatchMode.value.code === 'email')).length > 0;
    }, [accountPolicyData]);

    const applyDocPreferenceChanges = useCallback(() => {
        if (isEmailOptionSelected && !policyDocConsentValue) {
            return ModalNextProvider.showAlert({
                title: commonMessages.errorUploadTitle,
                message: messages.policyConsentSelectWarning,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }
        setIsLoading(true);
        const policiesValues = accountPolicyData.map((data) => data.value);
        PolicyService.updatePolicyDocumentPreference(policiesValues, authHeader)
            .then((res) => {
                updateStatus(SAVE_MESSAGES.saveDocPreferenceSuccess);
            })
            .catch((error) => {
                updateStatus(SAVE_MESSAGES.saveDocPreferenceError);
            }).finally(() => {
            setIsLoading(false);
        });
    }, [policyDocConsentValue, accountPolicyData, authHeader, PolicyService, isEmailOptionSelected, ModalNextProvider]);

    const readValue = useCallback((id, path) => _.get(formData, path), [formData]);

    const overrideProps = useMemo(
        () => ({
            '@field': {
                onValueChange: writeValue
            },
            policyDocTableContainer: {
                data: accountPolicyData
            },
            policyDocPreferenceTable: {
                data: accountPolicyData
            },
            myDocPreferenceError: {
                visible: status === SAVE_MESSAGES.saveDocPreferenceError
            },
            errorDocPreferenceMsg: {
                message: translator(messages[status])
            },
            myDocPreferenceSuccess: {
                visible: status === SAVE_MESSAGES.saveDocPreferenceSuccess
            },
            docPreferenceSuccessMsg: {
                message: translator(messages[status])
            },
            policyDocEmailConsentField: {
                visible: isEmailOptionSelected,
                value: policyDocConsentValue
            },
            savePolicyDocPreferenceData: {
                visible: accountPolicyData && accountPolicyData.length > 0
            },
            paperlessNotification:{
                visible: showPaperlessNotification
            }
        }),
        [writeValue, formData, status, accountPolicyData, policyDocConsentValue]
    );
    const resolvers = useMemo(
        () => ({
            resolveValue: readValue,
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getDataCell: getDataCell,
                getProductIcon: getProductIcon,
                getDocumentPreference: getDocumentPreference,
                applyDocPreferenceChanges,
                updatePolicyDocEmailConsentValue
            },
        }),
        [readValue, accountPolicyData, policyDocConsentValue]
    );
    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }
    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default GoPaperless;
